module.exports = __webpack_public_path__ + "static/img/SOUS-MAINS-PURE-ZONE-1.15-X-0.35.f218974.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/produits/SOUS-MAINS-PURE-ZONE-1.15-X-0.35.jpg
// module id = 9v/U
// module chunks = 0